import { palette } from '@repo/ui/theme';

const withAlpha = (hex: string, alpha: number): string => {
  const normalized = hex.replace('#', '');
  const bigint = parseInt(normalized, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const colorMap = {
  heartRate: {
    accent: palette.red,
    iconTint: withAlpha(palette.red, 0.12),
  },
  heartRateVariability: {
    accent: palette.yellow,
    iconTint: withAlpha(palette.yellow, 0.12),
  },
  respiratoryRate: {
    accent: palette.cyan,
    iconTint: withAlpha(palette.cyan, 0.12),
  },
  blue: {
    accent: palette.cyan,
    iconTint: withAlpha(palette.cyan, 0.12),
  },
  purple: {
    accent: palette.indigo,
    iconTint: withAlpha(palette.indigo, 0.12),
  },
  red: {
    accent: palette.red,
    iconTint: withAlpha(palette.red, 0.12),
  },
  green: {
    accent: palette.cyan,
    iconTint: withAlpha(palette.cyan, 0.12),
  },
} as const;

export type CardVariant = keyof typeof colorMap;
